var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileEmptyState = function SvgFileEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 126,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M181 51.168c0 49.935-36.673 102.542-85.876 58.077C45.921 64.779 0 101.103 0 51.168S39.63-14.074 73.938 13.79C108.245 41.656 181 1.233 181 51.168z",
    fill: props.accentFill
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.732 21.235l9.65 9.665H111.6a1.5 1.5 0 01-1.5-1.5V13.617l7.63 7.616.002.002z",
    stroke: "#363840",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.6 10l2.995 3H54v100h74V29.406l3 2.994V113a3 3 0 01-3 3H54a3 3 0 01-3-3V13a3 3 0 013-3h54.6z",
    fill: "#363840"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.9,
    y: 96.5,
    width: 31,
    height: 3,
    rx: 1.5,
    fill: "#363840",
    stroke: "#363840"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 71.5,
    width: 55,
    height: 3,
    rx: 1.5,
    fill: "#363840",
    stroke: "#363840"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 63.5,
    width: 55,
    height: 3,
    rx: 1.5,
    fill: "#363840",
    stroke: "#363840"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 55.5,
    width: 47,
    height: 3,
    rx: 1.5,
    fill: "#363840",
    stroke: "#363840"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 39.5,
    width: 31,
    height: 3,
    rx: 1.5,
    fill: "#363840",
    stroke: "#363840"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 61.5,
    y: 31.5,
    width: 15,
    height: 3,
    rx: 1.5,
    fill: "#363840",
    stroke: "#363840"
  })));
};
export default SvgFileEmptyState;